import angular from "angular";

let Levels = angular.module("Levels", []).constant(
  "Levels",
  (() => {
    const t = {};

    /* GENERAL */
    t.WHITE = 1;
    t.BLACK = 2;
    t.BLUE = 3;
    t.RED = 4;
    t.YELLOW = 5;
    t.GREEN = 6;

    return t;
  })()
).name;

export default Levels;



// WEBPACK FOOTER //
// ./client/app/constants/levels.js